import { gsap, Power2, Power1, Power3 } from 'gsap'
import { CustomEase } from 'gsap/CustomEase'
import { updateLocoScroll } from '../locomotive-scroll'
import {loadElementLazyImage} from "../helpers/lazy-load";
import {getCookie} from "../cookies";

gsap.registerPlugin(CustomEase);


export function setUpFirstBlock(){

  loadElementLazyImage($('.js-hero-mask'))
  let hasAcceptedCookies = getCookie('SEBConsents')

  if (window.innerWidth > 1000 && hasAcceptedCookies.length) {
    let tl = gsap.timeline({})
    tl.to('.js-hero-img', { scale: 1, duration: 0.6})
    tl.to('.js-hero-mask', {
      scale: 1,
      duration: 1.4,
      ease: Power3,
      //ease: CustomEase.create("custom", "M0,0 C0,0.48 0.016,0.734 0.338,0.926 0.475,1.008 0.752,1 1,1 "),
    })
    tl.to('.js-hero-img', {
      left: '-30%',
      duration: 1.4,
      ease: Power3,
      //ease: CustomEase.create("custom", "M0,0 C0,0.48 0.016,0.734 0.338,0.926 0.475,1.008 0.752,1 1,1 "),
    }, "<+=0.5")
    tl.to('.js-hero-title', { top: 0, duration: 0.6 }, ">-0.6")
    tl.to('.js-first-block-header', { top: 0, duration: 0.6 }, ">-0.4")
    tl.to('.js-hero-text', { opacity: 1, duration: 0.6 }, ">-0.4")
    tl.to('.scroll-down', {opacity: 1, duration: 0.4})

  }

  updateLocoScroll()


}
